var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextualHelpMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_49309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.8984C9.57813 15.0078 11.1133 13.293 12.1055 11.7539C13.0977 10.2148 13.5938 8.85937 13.5938 7.6875C13.5938 5.84375 13.0039 4.33594 11.8242 3.16406C10.6445 1.99219 9.20313 1.40625 7.5 1.40625C5.79687 1.40625 4.35547 1.99219 3.17578 3.16406C1.99609 4.33594 1.40625 5.84375 1.40625 7.6875C1.40625 8.85937 1.91406 10.2148 2.92969 11.7539C3.94531 13.293 5.46875 15.0078 7.5 16.8984ZM7.5 18.75C4.98437 16.6094 3.10547 14.6211 1.86328 12.7852C0.621094 10.9492 0 9.25 0 7.6875C0 5.34375 0.753906 3.47656 2.26172 2.08594C3.76953 0.695312 5.51563 0 7.5 0C9.48437 0 11.2305 0.695312 12.7383 2.08594C14.2461 3.47656 15 5.34375 15 7.6875C15 9.25 14.3789 10.9492 13.1367 12.7852C11.8945 14.6211 10.0156 16.6094 7.5 18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73295 13.125H8.4375V7.25329H6.73295V13.125ZM7.5 5.15378C7.76515 5.15378 7.98769 5.06867 8.16761 4.89844C8.34754 4.72821 8.4375 4.51069 8.4375 4.24589C8.4375 3.98109 8.34754 3.75411 8.16761 3.56497C7.98769 3.37582 7.76515 3.28125 7.5 3.28125C7.23485 3.28125 7.01231 3.37582 6.83239 3.56497C6.65246 3.75411 6.5625 3.98109 6.5625 4.24589C6.5625 4.51069 6.65246 4.72821 6.83239 4.89844C7.01231 5.06867 7.23485 5.15378 7.5 5.15378Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_49309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextualHelpMenu);
export default __webpack_public_path__ + "static/media/contextual-help-menu.8cedd3e469d755201a17dfbe19cca168.svg";
export { ForwardRef as ReactComponent };